import { FieldsGroupPresenter } from '@/forms/components/presenters/FieldsGroupPresenter';
import { FormFieldType, type FieldsGroupFormField } from '@/forms/typings';

import type { FormFieldModule } from '../registry/field-module.types';

import { buildFieldsGroupInitialState } from './initialState';

export const fieldsGroupFieldModule: FormFieldModule = {
  type: FormFieldType.FieldsGroup,
  Presenter: ({ field }) => (
    <FieldsGroupPresenter fieldsGroup={field as FieldsGroupFormField} />
  ),
  flattenLeaves: (field, ctx) => ctx.recurse((field as FieldsGroupFormField).fields),
  buildInitialState: buildFieldsGroupInitialState,
};
